export default __webpack_public_path__ + "static/media/right-arrow.a0351727.svg";